var render = function () {var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;
return _c('v-main',[_c('v-container',{attrs:{"fill-height":"","grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-card',{attrs:{"outlined":"","tile":""}},[_c('v-card-title',[_vm._v(" 시스템 오류가 발생하였습니다. ")]),_c('v-card-text',[_vm._v(" 요청된 URL "),_c('strong',[_vm._v(_vm._s(_vm.$data.variables.pathname))]),_vm._v("을(를) 서버에서 찾을 수 없습니다."),_c('br'),_vm._v(" 입력한 주소가 맞는지 다시 한 번 확인해주세요. ")])],1)],1)],1)],1)],1);}
var staticRenderFns = []

export { render, staticRenderFns }